import { Button } from "@/components/ui/button";
import { __ } from "@/i18n";
import { useWidgetStore } from "@/stores/widget-store";
import { saveWidgetConfig } from "@/services/widget";
import { useToast } from "@/hooks/use-toast";
import { useState } from "react";

export const WidgetPublish = () => {
  const [isPublishing, setIsPublishing] = useState(false);
  const widgetConfig = useWidgetStore((state) => state.config);
  const { toast } = useToast();

  const handlePublish = async () => {
    try {
      setIsPublishing(true);

      await saveWidgetConfig(widgetConfig);

      toast({
        title: __( 'Changes published successfully', 'accessibility-widget' ),
        variant: "success",
      });
    } catch {
      toast({
        title: __( 'Failed to publish changes', 'accessibility-widget' ),
        variant: "destructive",
      });
    } finally {
      setIsPublishing(false);
    }
  };

  return (
    <Button
      className="cy:rounded cy:text-base!"
      onClick={handlePublish}
      disabled={isPublishing}
    >
      {isPublishing ? __( 'Applying...', 'accessibility-widget' ) : __( 'Apply changes', 'accessibility-widget' )}
    </Button>
  );
};
